import React, { useEffect, useState } from "react";
import { Container, Row, Col, Nav, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

function CookieConsent() {

    return (
        <Container className="py-5">
            <Row>
                <Col lg={3} className="py-3 py-lg-0">
                    <h5 className="mb-3">Menu</h5>
                    <Nav className="flex-column">
                        <Link to="/shop" className="text-small text-decoration-none text-dark mb-3">Shop</Link>
                        <Link to="/executive-elegance" className="text-small text-decoration-none text-dark mb-3">Executive Elegance</Link>
                        <Link to="/arabian-ethereals" className="text-small text-decoration-none text-dark mb-3">Arabian Ethereals</Link>
                        <Link to="/alteration" className="text-small text-decoration-none text-dark mb-3">Alteration</Link>

                    </Nav>
                </Col>
                <Col lg={3} className="py-3 py-lg-0">
                    <h5 className="mb-3">About Us</h5>
                    <Nav className="flex-column">
                        <Link to="/about" className="text-small text-decoration-none text-dark mb-3">About</Link>
                        <Link to="/privacy-policy" className="text-small text-decoration-none text-dark mb-3">Privacy Policy</Link>
                        <Link to="/terms-of-service" className="text-small text-decoration-none text-dark mb-3">Terms of Service</Link>
                        <Link to="/refund-policy" className="text-small text-decoration-none text-dark mb-3">Refund Policy</Link>
                        <Link to="/delivery-and-shipment" className="text-small text-decoration-none text-dark mb-3">Delivery & Shipment</Link>
                    </Nav>
                </Col>
                <Col lg={3} className="py-3 py-lg-0">
                    <h5 className="mb-3">Subscribe to our Latest News</h5>
                    <Form>
                        <Form.Floating className="mb-3">
                            <Form.Control
                                id="name"
                                type="email"
                                placeholder="Email Address *"
                                className="rounded-0 border-0 border-bottom"
                            />
                            <label htmlFor="name">Email Address *</label>
                        </Form.Floating>
                        <div className="d-grid gap-2">
                            <Button variant="dark" size="sm" className="rounded-3" type="submit">
                                Subscribe
                            </Button>
                        </div>
                    </Form>
                </Col>
                <Col lg={2} className="mx-auto py-3 py-lg-0">
                    <h5 className="mb-3">Follow Us</h5>
                    <Nav className="">
                        <Link to="https://www.facebook.com/share/15mPdAFWW6/?mibextid=LQQJ4d" className="text-decoration-none text-dark mb-3"><FontAwesomeIcon icon={faFacebook} size="2x" /></Link>
                        <Link to="https://www.instagram.com/anaqah_uae?igsh=dmJhMTN3eWhuNWFr&utm_source=qr" className="text-decoration-none text-dark mb-3 ms-3"><FontAwesomeIcon icon={faInstagram} size="2x" /></Link>
                    </Nav>
                </Col>
            </Row>
        </Container>
    );
}

export default CookieConsent;